import React, { FC, ReactNode } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';

import ActionButton from 'components/action-button';
import Dialog from 'components/dialog';
import noop from 'utils/noop';

import CheckoutErrorCell from './checkout-error-cell';

interface ICheckoutErrorsModalProps {
  checkoutErrors: Array<{ messageId: string; message?: string | ReactNode }>;
  closeModal: () => void;
}

const CheckoutErrorsModal: FC<ICheckoutErrorsModalProps> = ({ checkoutErrors, closeModal }) => {
  const { formatMessage } = useIntl();

  const hasMoreThanOneError = checkoutErrors.length > 1;

  const errorsToBeDisplayed = checkoutErrors.map(({ messageId, message }) => (
    <CheckoutErrorCell
      key={messageId}
      showDot={hasMoreThanOneError}
      checkoutErrorId={messageId}
      message={message}
    />
  ));

  return (
    <Dialog
      onDismiss={noop} // Do nothing on dismiss
      heading={formatMessage({ id: 'unableToPlaceOrder' })}
      bodyComponent={errorsToBeDisplayed}
      actions={
        <Box center width="100%" margin="2rem 0 0">
          <ActionButton onClick={closeModal} data-testid="action-button-okay-checkout-errors">
            {formatMessage({ id: 'okay' })}
          </ActionButton>
        </Box>
      }
      modalAppearanceEventMessage="Checkout Errors Dialog"
      data-testid="checkout-errors-dialog"
    />
  );
};

export default CheckoutErrorsModal;
